module.exports = __webpack_public_path__ + "img/step4.4410cd83.png";